(() => {
  const mountHeaderMegaMenus = (root = document) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const header = scope.matches?.('[data-header]') ? scope : scope.querySelector?.('[data-header]');
    if (!header) return;

    const sectionRoot = header.closest('.shopify-section') || header.parentElement;
    const registry = sectionRoot?.querySelector('[data-header-mega-registry]');
    if (!registry) return;

    const entries = Array.from(registry.querySelectorAll('[data-header-mega-entry]'));
    const activeOwners = new Set(entries.map((entry) => entry.dataset.headerMegaOwner).filter(Boolean));
    const activeHandles = new Set(entries.map((entry) => entry.dataset.menuHandle).filter(Boolean));

    sectionRoot.querySelectorAll('[data-header-mega-mounted]').forEach((panel) => {
      if (!activeOwners.has(panel.dataset.headerMegaMounted)) panel.remove();
    });

    header.querySelectorAll('.nav-links__item[data-mega-mounted-handle]').forEach((item) => {
      if (activeHandles.has(item.dataset.megaMountedHandle)) return;
      const fallback = item.querySelector('[data-nav-dropdown-fallback]');
      const trigger = item.querySelector('.nav-links__link');
      item.classList.remove('nav-links__item--has-mega');
      delete item.dataset.megaMountedHandle;
      delete item.dataset.megaWidth;
      fallback?.removeAttribute('hidden');
      item.querySelector('[data-dropdown-chevron]')?.removeAttribute('hidden');
      if (fallback) {
        trigger?.setAttribute('aria-controls', fallback.id);
      } else {
        item.classList.remove('nav-links__item--has-dropdown');
        item.removeAttribute('data-nav-dropdown');
        item.removeAttribute('data-reveal-group');
        item.removeAttribute('data-reveal-trigger');
        trigger?.removeAttribute('data-dropdown-trigger');
        trigger?.removeAttribute('aria-expanded');
        trigger?.removeAttribute('aria-controls');
        item.querySelector('[data-potential-dropdown-chevron]')?.setAttribute('hidden', '');
      }
    });

    sectionRoot.querySelectorAll('.mobile-nav__item[data-mega-mounted-handle]').forEach((item) => {
      if (activeHandles.has(item.dataset.megaMountedHandle)) return;
      const fallback = item.querySelector('[data-mobile-menu-fallback]');
      const trigger = item.querySelector('.mobile-nav__link');
      delete item.dataset.megaMountedHandle;
      fallback?.removeAttribute('hidden');
      trigger?.removeAttribute('data-mobile-mega-open');
      trigger?.removeAttribute('data-mobile-mega-target');
      trigger?.removeAttribute('data-sidebar-panel-open');
      trigger?.removeAttribute('data-sidebar-panel-target');
      trigger?.removeAttribute('aria-controls');
      trigger?.classList.remove('mobile-nav__mega-link');
      if (fallback) {
        trigger?.setAttribute('data-mobile-toggle', '');
        trigger?.setAttribute('aria-controls', fallback.id);
      } else {
        item.classList.remove('mobile-nav__item--has-children');
        trigger?.removeAttribute('aria-expanded');
        item.querySelector('[data-potential-dropdown-chevron]')?.setAttribute('hidden', '');
      }
    });

    entries.forEach((entry) => {
      const handle = entry.dataset.menuHandle;
      const owner = entry.dataset.headerMegaOwner;
      if (!handle) return;

      const desktopItem = header.querySelector(`.nav-links__item[data-menu-handle="${CSS.escape(handle)}"]`);
      const desktopPanel = entry.querySelector('[data-header-mega-desktop] > [data-axiom-mega-rows]');

      if (desktopItem && desktopPanel) {
        desktopItem.querySelectorAll('[data-header-mega-mounted]').forEach((panel) => {
          if (panel !== desktopPanel) panel.remove();
        });
        desktopItem.classList.add('nav-links__item--has-dropdown', 'nav-links__item--has-mega');
        desktopItem.dataset.megaMountedHandle = handle;
        desktopItem.setAttribute('data-nav-dropdown', '');
        desktopItem.setAttribute('data-reveal-group', '');
        desktopItem.setAttribute('data-reveal-trigger', 'open');
        desktopItem.dataset.megaWidth = entry.dataset.megaWidth || 'full';
        desktopPanel.classList.toggle('axiom-mega-rows--width-header', entry.dataset.megaWidth === 'header');
        desktopPanel.dataset.megaColumnGap = entry.dataset.megaColumnGap || 'medium';
        desktopPanel.dataset.megaVerticalPadding = entry.dataset.megaVerticalPadding || 'medium';
        desktopPanel.dataset.showLinkUnderline = entry.dataset.megaUnderline;
        desktopPanel.dataset.headerMegaMounted = owner;
        const desktopTrigger = desktopItem.querySelector('.nav-links__link');
        if (desktopTrigger) {
          // A disclosure, not an ARIA menu: expanded state plus the panel it controls.
          desktopTrigger.setAttribute('data-dropdown-trigger', '');
          desktopTrigger.setAttribute('aria-expanded', 'false');
          desktopTrigger.setAttribute('aria-controls', desktopPanel.id);
        }
        desktopItem.querySelector('[data-nav-dropdown-fallback]')?.setAttribute('hidden', '');
        desktopItem.querySelector('[data-dropdown-chevron]')?.setAttribute('hidden', '');
        desktopItem.append(desktopPanel);
      }

      const mobileItem = sectionRoot.querySelector(`.mobile-nav__item[data-menu-handle="${CSS.escape(handle)}"]`);
      const mobilePanel = entry.querySelector('[data-mobile-mega-panel]');
      const mobilePanels = sectionRoot.querySelector('[data-mobile-mega-panels]');

      if (mobileItem && mobilePanel && mobilePanels) {
        mobilePanels.querySelectorAll(`[id="${CSS.escape(mobilePanel.id)}"]`).forEach((panel) => {
          if (panel !== mobilePanel) panel.remove();
        });
        mobileItem.classList.add('mobile-nav__item--has-children');
        mobileItem.dataset.megaMountedHandle = handle;
        const trigger = mobileItem.querySelector('[data-mobile-toggle], .mobile-nav__link');
        const fallback = mobileItem.querySelector('[data-mobile-menu-fallback]');
        if (trigger) {
          trigger.removeAttribute('data-mobile-toggle');
          trigger.setAttribute('data-mobile-mega-open', '');
          trigger.setAttribute('data-mobile-mega-target', mobilePanel.id);
          trigger.setAttribute('data-sidebar-panel-open', '');
          trigger.setAttribute('data-sidebar-panel-target', mobilePanel.id);
          trigger.setAttribute('aria-controls', mobilePanel.id);
          trigger.setAttribute('aria-expanded', 'false');
          trigger.classList.add('mobile-nav__mega-link');
        }
        mobileItem.querySelector('[data-potential-dropdown-chevron]')?.removeAttribute('hidden');
        fallback?.setAttribute('hidden', '');
        mobilePanel.dataset.showBanners = entry.dataset.showBannersMobile;
        mobilePanel.dataset.bannerPosition = entry.dataset.mobileBannerPosition || 'after';
        mobilePanel.dataset.headerMegaMounted = owner;
        mobilePanels.append(mobilePanel);
      }
    });
  };

  window.Axiom = window.Axiom || {};
  window.Axiom.mountHeaderMegaMenus = mountHeaderMegaMenus;

  const reconcileMegaMenus = () => requestAnimationFrame(() => mountHeaderMegaMenus(document));
  document.addEventListener('shopify:block:load', reconcileMegaMenus);
  document.addEventListener('shopify:block:unload', reconcileMegaMenus);
})();
